
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import confirmationDialog from "../dialogs/confirmation-dialog.vue";
export default {
  components: { confirmationDialog },
  props: {
    property: {
      type: String,
      default: ""
    },
    subProperty: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    attributes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedAttribute: "",
      expand: false,
      showItemDeleteConfirmationDialog: false
    };
  },
  computed: {
    ...mapState("menu", [
      "categories",
      "menuUploadDragSelection",
      "menuUploadList"
    ])
  },

  methods: {
    ...mapMutations("menu", [
      "SET_MENU_UPLOAD_LIST_PROP",
      "SET_MENU_UPLOAD_LIST",
      "SET_MENU_UPLOAD_DRAG_SELECTION"
    ]),
    shouldDisableCategories(listItem) {
      // Get all selected items
      if (this.id === "set-category") {
        const selectedItems = this.menuUploadList.filter((item) =>
          this.menuUploadDragSelection.includes(item.id)
        );

        const shouldDisable = selectedItems.some((item) => {
          const matchesCategory =
            listItem.id !== null &&
            item.category_id !== null &&
            listItem.id === item.category_id;
          const matchesSubCategory =
            listItem.id !== null &&
            item.sub_category_id !== null &&
            listItem.id === item.sub_category_id;
          const matchesParentAsCategory =
            listItem.parent_id !== null &&
            item.category_id !== null &&
            listItem.parent_id === item.category_id;
          const matchesParentAsSubCategory =
            listItem.parent_id !== null &&
            item.sub_category_id !== null &&
            listItem.parent_id === item.sub_category_id;
          const categoryWithSubcategory =
            listItem.subAttributes && listItem.subAttributes.length > 0;

          return (
            matchesCategory ||
            (matchesSubCategory && matchesParentAsCategory) ||
            matchesParentAsSubCategory ||
            categoryWithSubcategory
          );
        });
        return shouldDisable;
      } else if (this.id === "dish-type") {
        const selectedItems = this.menuUploadList.filter((item) =>
          this.menuUploadDragSelection.includes(item.id)
        );
        const shouldDisable = selectedItems.some((item) => {
          const matchesDishType = listItem.id === item.dish_type;
          return matchesDishType;
        });
        return shouldDisable;
      }

      return false;
    },
    categoryChanged() {
      if (this.selectedAttribute && this.menuUploadDragSelection.length > 0) {
        const isSubAttribute = this.selectedAttribute.level > 0;
        this.SET_MENU_UPLOAD_LIST_PROP({
          ids: this.menuUploadDragSelection,
          propName: this.property,
          propValue: isSubAttribute
            ? this.selectedAttribute.parent_id
            : this.selectedAttribute.id,
          subPropName: isSubAttribute ? this.subProperty : null,
          subPropValue: isSubAttribute ? this.selectedAttribute.id : null
        });
        this.SET_MENU_UPLOAD_DRAG_SELECTION([]);
        this.$nuxt.$emit("clear-menu-upload-item-selection");
      }
    },
    handleDeleteItem() {
      const updatedMenuUploadList = this.menuUploadList.filter(
        (item) => !this.menuUploadDragSelection.includes(item.id)
      );
      this.SET_MENU_UPLOAD_LIST(updatedMenuUploadList);
      this.SET_MENU_UPLOAD_DRAG_SELECTION([]);
      this.$nuxt.$emit("clear-menu-upload-item-selection");
    },
    handleDialogClose() {
      this.SET_MENU_UPLOAD_DRAG_SELECTION([]);
      this.$nuxt.$emit("clear-menu-upload-item-selection");
    }
  }
};
